exports.version = "1.9.3"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 1582
// module chunks = 9